import React from 'react';
import { ShieldCheckIcon, AlertTriangleIcon } from 'lucide-react';
const importantRules = ['There will be certified Range Officers embedded with each Squad during the match to ensure safety and rules are followed.', '22 caliber pistols can be carried during the match, using your holster during. However with rimfire you will be shooting from a "low-ready" position on the firing line, rather than in the holster. ONLY centerfire pistols will be allowed to run from the holstered start.', 'Pistol and rifle are to be moved around the stages in a bag or on a cart.', 'NO IWB Holsters allowed.', 'Ammo - Bring 150+ rounds for each gun you run.', 'Shooting will be done from a stationary position. Twisting and shooting with 1 stage having movement is required.'];
export function ImportantRules() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3472">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3473">
        <div className="mb-12" data-id="element-3474">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3475">
            Important Rules & Notes
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3476">
            <div className="space-y-5" data-id="element-3477">
              {importantRules.map((rule, index) => <div key={index} className="flex items-start gap-4" data-id="element-3478">
                  <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: index === 0 ? 'rgba(30,61,47,0.08)' : 'rgba(200,168,75,0.1)'
              }} data-id="element-3479">
                    {index === 0 ? <ShieldCheckIcon size={16} style={{
                  color: '#1e3d2f'
                }} data-id="element-3480" /> : <AlertTriangleIcon size={16} style={{
                  color: '#c8a84b'
                }} data-id="element-3481" />}
                  </div>
                  <p className="text-base leading-relaxed" style={{
                color: '#2a2a2a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-3482">
                    {index === 1 ? <>
                        <strong className="underline" data-id="element-3483">NOTE:</strong> {rule}
                      </> : rule}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}